<template>
  <div
    class="card mt-3"
    style="box-shadow: 0 4px 10px -4px rgba(0, 0, 0, 0.5)"
  >
    <div class="card-body p-4">
      <h6 class="mb-3 fw-bold" style="font-size: 14px">
        Resumen de vendedores
      </h6>
      <div v-if="loadingCompanyLeads" class="small text-muted">
        Cargando...
      </div>
      <div v-else-if="sellersSummary.length > 0" class="table-responsive">
        <table
          class="table table-sm table-borderless mb-0"
          style="font-size: 12px"
        >
          <thead>
            <tr style="border-bottom: 1px solid #dee2e6">
              <th>Vendedor</th>
              <th class="text-center">Referidos</th>
              <th class="text-center">Perdidos</th>
              <th class="text-center">Ganados</th>
              <th class="text-center">% Efectividad</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="row in sellersSummary"
              :key="row.userId"
              style="border-bottom: 1px solid #eee"
            >
              <td>{{ row.sellerName }}</td>
              <td class="text-center">{{ row.referidos }}</td>
              <td class="text-center">{{ row.perdidos }}</td>
              <td class="text-center">{{ row.ganados }}</td>
              <td class="text-center fw-bold">{{ row.efectividadPct }}%</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="small text-muted">
        No hay datos de vendedores.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CompanyStats",
  props: {
    userId: { type: String, required: true },
    tokenAuth: { type: String, required: true },
  },
  data() {
    return {
      companyLeads: [],
      loadingCompanyLeads: false,
    };
  },
  computed: {
    sellersSummary() {
      const byUser = {};
      this.companyLeads.forEach((lead) => {
        const uid = lead.userId || "sin-asignar";
        if (!byUser[uid]) {
          const names = lead.promoterNames ?? "";
          const lastnames = lead.promoterLastnames ?? "";
          const sellerName =
            [names, lastnames].filter(Boolean).join(" ").trim() || "Sin nombre";
          byUser[uid] = {
            userId: uid,
            sellerName,
            referidos: 0,
            perdidos: 0,
            ganados: 0,
          };
        }
        byUser[uid].referidos += 1;
        if (lead.completed === true) byUser[uid].perdidos += 1;
        if (lead.status === "INSTALADO: Contrato instalado")
          byUser[uid].ganados += 1;
      });
      return Object.values(byUser)
        .map((row) => ({
          ...row,
          efectividadPct:
            row.referidos === 0
              ? 0
              : Math.round((row.ganados / row.referidos) * 100),
        }))
        .sort((a, b) => b.efectividadPct - a.efectividadPct);
    },
  },
  mounted() {
    this.fetchCompanyLeads();
  },
  methods: {
    fetchCompanyLeads() {
      this.loadingCompanyLeads = true;
      this.$https
        .post("/administration/fetchCompanyLeadsForAdmin", {
          tokenAuth: this.tokenAuth,
          userId: this.userId,
        })
        .then((res) => {
          this.companyLeads = res.data.sales || [];
        })
        .catch((err) => {
          console.error("Error fetching company leads:", err);
        })
        .finally(() => {
          this.loadingCompanyLeads = false;
        });
    },
  },
};
</script>
